import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCurrencyStyle0 = cosmosIconCss;

const CosmosIconCurrency$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCurrency extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1041e9a2640ee7e0f24ac8d2e5f9507dcb89cf75', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3a191340c8a1630efc4c1e29cf61b2669ce742b7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c6f2ddc119441ac3c088df22af75d5641d7e36cd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.495 4H19.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-9H5.495a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5ZM2.5 7.49h13.505a.5.5 0 0 1 .5.5v9.51a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5V7.99a.508.508 0 0 1 .5-.5Zm12.504 9.01H9.813v-1.08a1.632 1.632 0 0 0 1.59-1.6c0-.75-.39-1.16-1.45-1.59l-.69-.25c-.58-.22-.74-.36-.74-.67 0-.35.27-.56.73-.56.324-.03.63.157.75.46a.307.307 0 0 0 .28.22h.72c.17 0 .24-.11.21-.24a1.625 1.625 0 0 0-1.4-1.34v-.86h5.191v7.51ZM8.672 8.99H3.501v7.51h5.171v-1.1a1.772 1.772 0 0 1-1.54-1.5c-.02-.13.04-.23.21-.23h.74c.136 0 .253.097.28.23a.876.876 0 0 0 .92.59c.56 0 .88-.22.88-.6 0-.35-.17-.51-.75-.71l-.66-.24c-1.01-.38-1.45-.86-1.45-1.6a1.53 1.53 0 0 1 1.37-1.49v-.86Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCurrencyStyle0; }
}, [1, "cosmos-icon-currency", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-currency"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-currency":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCurrency$1);
            }
            break;
    } });
}

const CosmosIconCurrency = CosmosIconCurrency$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCurrency, defineCustomElement };
